import { i18n } from '@lingui/core';

export interface NewRheologyPageParams extends Record<string, string | undefined> {
    entityId: string
  }
export const ROUTE_PARAM_IDENTIFIER = ':entityId';

export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/rheology/new`;
export const TITLE = i18n._('New Rheology Data');
